export default {"src":"/_next/static/media/beverage.50941f50.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};